import { ComponentType, FC } from 'react';
import { UseApplePayResults, useApplePay } from 'hooks/apple-pay/useApplePay';

export type WithApplePayProps = Partial<UseApplePayResults>;

export const withApplePay = <P extends object>(
  WrappedComponent: ComponentType<P>
): FC<P & WithApplePayProps> => {
  const WrappedWithApplePay = (props: P) => {
    const applePay = useApplePay(props);
    return <WrappedComponent {...applePay} {...props} />;
  };

  const componentName = WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
  WrappedWithApplePay.displayName = `WithApplePay(${componentName})`;

  return WrappedWithApplePay;
};
